import React, { useEffect, useState } from 'react';
import AUX from '../../../hoc/Aux_';
import { Button } from 'reactstrap';
import Dropdown from '../filters/Dropdown';
import { useDispatch, useSelector } from 'react-redux';
import {
  getLeaveBalance,
  getMember,
  getTeams,
} from '../../../redux/MainAction';
import PaginationComponent from '../filters/PaginationComponent';

const BalanceList = () => {
  const dispatch = useDispatch();
  const leave = useSelector((state) => state?.Webtracker?.leaveBalance);
  const emp = useSelector((state) => state?.Webtracker?.member);
  const tms = useSelector((state) => state?.Webtracker?.teams);

  const [isChecked, setIsChecked] = useState(false);

  const [showReset, setShowReset] = useState(false);

  const [leaveData, setLeaveData] = useState([]);

  const [page, setPage] = useState(1); // Current page
  const [totalPages, setTotalPages] = useState(0); // Total number of pages
  const itemsPerPage = 10;

  const [filters, setFilters] = useState({
    employeeIds: '',
    teamIds: '',
  });

  const onChangeFilter = (e) => {
    const { name, value } = e.target;
    setFilters({ ...filters, [name]: value });
  };

  useEffect(() => {
    getList();
  }, [isChecked, page]);

  useEffect(() => {
    var data = {
      offset: 0,
      limit: 100,
    };
    dispatch(getMember(data));
    dispatch(getTeams(data));
  }, []);

  const getList = () => {
    var data = {
      offset: (page - 1) * itemsPerPage,
      limit: itemsPerPage,
      isCurrentlyOnLeave: isChecked,
    };

    dispatch(getLeaveBalance(data));
  };

  const handleCheckboxChange = () => {
    setIsChecked(!isChecked);
  };
  const [isChecked1, setIsChecked1] = useState(false);

  useEffect(() => {
    if (leave && leave.rows) {
      setLeaveData(leave?.rows);
      setTotalPages(Math.ceil(leave?.count / itemsPerPage));
    }
  }, [leave, page]);

  const handleCheckboxChange1 = () => {
    setIsChecked1(!isChecked1);
  };
  console.log('leave', leave);

  const handleApply = (e) => {
    e.preventDefault();

    // Build the payload dynamically, excluding invalid or empty fields
    const payload = {
      offset: 0,
      limit: 10,
    };

    if (filters?.employeeIds !== '') {
      payload.employeeIds = [filters.employeeIds];
    }

    if (filters?.teamIds !== '') {
      payload.teamIds = [filters.teamIds];
    }
    // Dispatch the action with the constructed payload
    dispatch(getLeaveBalance(payload));
    setShowReset(true);
  };

  const handleReset = () => {
    const payload = {
      offset: 0,
      limit: 10,
    };
    dispatch(getLeaveBalance(payload));
    setFilters({
      employeeIds: '',
      teamIds: '',
    });
    setShowReset(false);
  };

  const handlePageChange = (event, value) => {
    setPage(value);
  };

  return (
    <AUX>
      <div className="page-content-wrapper">
        <div className="container-fluid">
          <div className="row">
            <div className="col-12">
              <div className="row">
                <div className="col-12">
                  <div className="card m-b-10">
                    <div className="card-body">
                      <div className="d-flex justify-content-between align-items-center ">
                        <div
                          className="d-flex justify-content-start align-items-center "
                          style={{ gap: '10px' }}
                        >
                          <div className="fillSelect">
                            <i className="mdi mdi-account font-20 fillIcon"></i>
                            <select
                              className="form-control font-14"
                              name="employeeIds"
                              value={filters?.employeeIds}
                              onChange={onChangeFilter}
                            >
                              <option value={undefined}>All Members</option>
                              {emp?.rows?.map((mems, idx) => (
                                <option key={idx} value={mems?.id}>
                                  {mems?.firstName} {mems?.lastName}
                                </option>
                              ))}
                            </select>
                          </div>
                          <div className="fillSelect">
                            <i className="mdi mdi-account font-20 fillIcon"></i>
                            <select
                              className="form-control font-14"
                              name="teamIds"
                              value={filters?.teamIds}
                              onChange={onChangeFilter}
                            >
                              <option value={undefined}>All Teams</option>
                              {tms?.rows?.map((mems, idx) => (
                                <option key={idx} value={mems?.id}>
                                  {mems?.name}
                                </option>
                              ))}
                            </select>
                          </div>
                          <Button
                            className="d-flex align-items-center justify-content-center"
                            style={{ padding: '6px 14px' }}
                            size="sm"
                            color="primary"
                            onClick={handleApply}
                          >
                            <i className="ion-ios7-search font-20"></i>
                          </Button>
                          {showReset ? (
                            <Button
                              className="d-flex align-items-center justify-content-center"
                              style={{ padding: '6px 13px' }}
                              size="sm"
                              color="danger"
                              onClick={handleReset}
                            >
                              <i className="mdi mdi-close font-20"></i>
                            </Button>
                          ) : (
                            ''
                          )}
                        </div>
                      </div>
                      <div className="d-flex ml-1" style={{ gap: '20px' }}>
                        <label
                          className="d-flex align-items-center text-muted mt-2"
                          style={{ cursor: 'pointer', fontWeight: '100' }}
                        >
                          <input
                            type="checkbox"
                            checked={isChecked}
                            onChange={handleCheckboxChange}
                            className="mr-2 text-muted"
                          />
                          Currently on leave
                        </label>
                        {/* <label className='d-flex align-items-center text-muted mt-2' style={{cursor:'pointer', fontWeight:'100'}}>
                            <input
                            type="checkbox"
                            checked={isChecked1}
                            onChange={handleCheckboxChange1}
                            className='mr-2 text-muted'
                            
                            />
                            Exclude archived
                        </label> */}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="card m-b-20">
                <div className="card-body">
                  <div>
                    <table
                      id="datatable"
                      className="table dt-responsive nowrap table-vertical"
                      width="100%"
                      cellSpacing="0"
                    >
                      <thead>
                        <tr>
                          <th>No.</th>
                          <th>Members</th>
                          <th>Team</th>
                          <th>Leave Policy</th>
                          <th>Used</th>
                          <th>Balance</th>
                        </tr>
                      </thead>
                      <tbody>
                        {leaveData?.length > 0 ? (
                          leaveData?.map((lvs, idx) => (
                            <tr key={idx}>
                              <td>{idx + 1 + (page - 1) * itemsPerPage}</td>
                              <td>
                                {lvs?.user?.firstName} {lvs?.user?.lastName}
                              </td>
                              <td>
                                {lvs?.teams?.length > 0
                                  ? lvs?.teams?.map((tms, idx) => (
                                      <span
                                        key={idx}
                                        className="table-team-name"
                                      >
                                        {tms?.name}
                                      </span>
                                    ))
                                  : '--'}
                              </td>
                              <td>{lvs?.leavePolicies[0]?.name || '--'}</td>
                              <td>
                                {Math.abs(
                                  lvs?.leavePolicies[0]?.balanceUsed || 0
                                )}{' '}
                                days
                              </td>
                              <td>
                                {Math.abs(
                                  parseInt(lvs?.leavePolicies[0]?.balance) || 0
                                )}{' '}
                                days
                              </td>
                            </tr>
                          ))
                        ) : (
                          <tr>
                            <td colSpan="8" className="text-center">
                              No Records Found.
                            </td>
                          </tr>
                        )}
                        {/* Add other rows as needed */}
                      </tbody>
                    </table>
                  </div>
                  <div className="mt-2">
                    <PaginationComponent
                      count={totalPages}
                      page={page}
                      onPageChange={handlePageChange}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </AUX>
  );
};

export default BalanceList;
